import * as React from 'react'
// components
import PlanDetails from 'components/PageComponents/Plans/Edit/components/SidebarInfo'
import PlanDetailsAPI from 'containers/Plan/Details/layers/API/index'

const PlanEditContainer: React.FC = () => (
  <PlanDetailsAPI>
    <PlanDetails />
  </PlanDetailsAPI>
)

export default PlanEditContainer
